// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__Tg_tW","header__wrapper":"style_header__wrapper__cvS7_","header-logo":"style_header-logo__3j4Nt"};